export default "__VITE_ASSET__9d1d1ce7__"